import { ListSelectionStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { FieldProps } from 'formik';
import { FC, Fragment } from 'react';

const UserStatus: FC<FieldProps> = ({ form }) => {
  return (
    <Fragment>
      {
        <Box data-testid="success" flexDirection={{ sm: 'column' }}>
          <SubListSelectionStyled>
            <Box alignItems={{ sm: 'center' }}>
              <Text size="400" weight="600" color="bechtel.grey.1000">
                <Trans>Status</Trans>
              </Text>
            </Box>
          </SubListSelectionStyled>
          <ListSelectionStyled
            data-testid="success"
            onClick={() => {
              form.setFieldValue('activeUser', !form.values.activeUser);
            }}
          >
            <Box mr={{ sm: '500' }}>
              <Checkbox checked={form.values.activeUser === true} readOnly />
            </Box>
            <Text color="bechtel.colors.grey.1000" size="400">
              <Trans>Active</Trans>
            </Text>
          </ListSelectionStyled>
          <ListSelectionStyled
            data-testid="inactive-user"
            onClick={() => {
              form.setFieldValue('inActiveUser', !form.values.inActiveUser);
            }}
          >
            <Box mr={{ sm: '500' }}>
              <Checkbox checked={form.values.inActiveUser === true} readOnly />
            </Box>
            <Text color="bechtel.colors.grey.1000" size="400">
              <Trans>Inactive</Trans>
            </Text>
          </ListSelectionStyled>
        </Box>
      }
    </Fragment>
  );
};

export default UserStatus;
